import React, {useState} from 'react';

import Authorize from 'features/auth/components/Auth/Auth';
import VipListContainer from 'features/vip/containers/VipListContainer';
import VipPackageContainer from 'features/vip/containers/VipPackageContainer';
import DashboardListingsContainer from 'features/dashboard/containers/DashboardListingsContainer';
import {withRouter} from '../../../../utils/helpers';

const BirdeyeBusinessesContainer = React.lazy(() =>
    import('features/listings/containers/BirdeyeBusinessesContainer'),
);

import {VipContainer, VipPackage} from './styles';
import Tab from 'features/generic/components/Tab/Tab';

/**
 * Hide line graph from internal users for RB Account
 */
const InternalAdminDashboard = (props) => {
    const VIP_STATE_SUBSCRIPTIONS = 'VIP State Subscriptions';
    const PACKAGES = 'Packages';
    const BIRDEYE_BUSINESSES = 'Birdeye Businesses';
    const [activeTab, setActiveTab] = useState(VIP_STATE_SUBSCRIPTIONS);

    return (
        <>
            <DashboardListingsContainer {...props} />
            <div className="h3" style={{margin: '24px 30px'}}>
                VIP
            </div>
            <Authorize permissions={['vipSubscription-view-all', 'vipPackage-view-all']}>
                <div style={{marginLeft: '30px'}}>
                    <Tab
                        isActive={activeTab === VIP_STATE_SUBSCRIPTIONS}
                        onClick={() => setActiveTab(VIP_STATE_SUBSCRIPTIONS)}>
                        {VIP_STATE_SUBSCRIPTIONS}
                    </Tab>
                    <Tab
                        isActive={activeTab === PACKAGES}
                        onClick={() => setActiveTab(PACKAGES)}>
                        {PACKAGES}
                    </Tab>
                    <Tab
                        isActive={activeTab === BIRDEYE_BUSINESSES}
                        onClick={() => setActiveTab(BIRDEYE_BUSINESSES)}>
                        {BIRDEYE_BUSINESSES}
                    </Tab>
                </div>
                <VipContainer show={activeTab === VIP_STATE_SUBSCRIPTIONS}>
                    <VipListContainer />
                </VipContainer>
                <VipContainer show={activeTab === PACKAGES}>
                    <VipPackageContainer $css={VipPackage} />
                </VipContainer>
                <VipContainer show={activeTab === BIRDEYE_BUSINESSES}>
                    <BirdeyeBusinessesContainer {...props} />
                </VipContainer>
            </Authorize>
        </>
    );
};

export default withRouter(InternalAdminDashboard);
